export const staticData_prod = {
    id: 'blyeTfqO0X1ZF4JLIUeV',
    userUUID: '689ee37131d7c6f34182e43a',
    chat_username: 'HOME User',
    user_email: 'emo homeproduser@maybetech.com',
    isGHLUser: false,
    address: "",
    agenct_config: {
        PluginOn: true,
        allow: true,
        plugins: [],
        agent_limit: 100
    },
    agency_id: "67e13b8ce6f157d42d5f930e",
    agentBuilder: null,
    apps: ['AI Social App'],
    assistants: [],
    business_name: "HOME",
    city: "",
    conversationId: "",
    country: "",
    createdAt: "2025-08-14T10:19:24.353Z",
    email: "emo+homeprod@maybetech.com",
    first_name: "",
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 0,
    nango_connected: false,
    number_of_additional_accounts: 0,
    onboarding: {
        website_url: 'www.home.cc',
        email: 'emo+homeprod@maybetech.com',
        verified: true
    },
    openAgentBuilder: false,
    phone_number: "",
    promptlabels_ids: [],
    selected_assistant_id: null,
    state: "",
    time_zone: "Europe/London",
    type: "free",
    updatedAt: "2025-08-18T10:44:01.534Z",
    userId: "689ee37131d7c6f34182e438",
    zip_code: "",
    __v: 0,
    _id: "689db82c982930215d7da4b1"
};

export const staticDataIframe_prod = {
    UserInfo: {
        userName: 'Polly Barnfield',
        email: 'polly+test@maybetech.com',
        _id: '673a00224ae9905c8b276c77',
        userId: 'XuSEhgIqvTFqKLvAmeb5'
    },
    active_integrations: [],
    address: "Cheadle Orchard",
    agenct_config: { PluginOn: false, plugins: [] },
    agency_id: "6739f1be347a7f5974735cec",
    agentBuilder: "asst_D5K6HataCHojqCENTKRst6xm",
    apps: ['Your AI'],
    assistants: ['asst_Z2rKLUaW5oqH3uJJSIVGnv8H'],
    business_name: "Maybe* The Big AI Secret",
    chat_username: "Polly Barnfield",
    city: "Shropshire",
    conversationId: "",
    country: "United Kingdom",
    createdAt: "2025-10-29T23:24:05.038Z",
    email: "polly+bais@maybetech.com",
    first_name: "",
    id: "ZpknpTCqEq5vka9cmnU6",
    isAuto: true,
    isGHLUser: false,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 25,
    monthly_token_usage: 46,
    nango_connected: false,
    number_of_additional_accounts: 0,
    number_of_ai_agents: 0,
    number_of_created_agents: 0,
    number_of_team_member: 4,
    number_of_tokens: 1,
    onboarding: { website_url: 'www.maybetech.com', email: 'polly+test@maybetech.com', verified: true },
    openAgentBuilder: false,
    phone_number: "07778956734",
    planType: "monthly",
    plan_id: "6762d4fa776cc2787280b1d0",
    promptlabels_ids: ['6902a10e140144736659574d'],
    selected_assistant_id: null,
    state: "Shropshire",
    time_zone: "Europe/London",
    type: "free",
    unlimited_ai_agents: true,
    updatedAt: "2025-11-04T15:43:19.296Z",
    useAgent: false,
    userId: null,
    userUUID: "673a00224ae9905c8b276c77",
    user_email: "polly+test@maybetech.com",
    zip_code: "TF93RW",
    __v: 0,
    _id: "6902a215140144736659734e"
};

export const staticData_dev = {
    id: 'blyeTfqO0X1ZF4JLIUeV',
    userUUID: '689ee37131d7c6f34182e43a',
    chat_username: 'HOME User',
    user_email: 'emo homeproduser@maybetech.com',
    isGHLUser: false,
    address: "",
    agenct_config: {
        PluginOn: true,
        allow: true,
        plugins: [],
        agent_limit: 100
    },
    agency_id: "67e13b8ce6f157d42d5f930e",
    agentBuilder: null,
    apps: ['AI Social App'],
    assistants: [],
    business_name: "HOME",
    city: "",
    conversationId: "",
    country: "",
    createdAt: "2025-08-14T10:19:24.353Z",
    email: "emo+homeprod@maybetech.com",
    first_name: "",
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 0,
    nango_connected: false,
    number_of_additional_accounts: 0,
    onboarding: {
        website_url: 'www.home.cc',
        email: 'emo+homeprod@maybetech.com',
        verified: true
    },
    openAgentBuilder: false,
    phone_number: "",
    promptlabels_ids: [],
    selected_assistant_id: null,
    state: "",
    time_zone: "Europe/London",
    type: "free",
    updatedAt: "2025-08-18T10:44:01.534Z",
    userId: "689ee37131d7c6f34182e438",
    zip_code: "",
    __v: 0,
    _id: "689db82c982930215d7da4b1"
};

// ...existing code...
export const staticDataIframe_dev = {
    id: 'Bgiio44eTEbQjTQy1e3A',
    userUUID: '68f213784deb09185c37957f',
    chat_username: 'Bilal Dev Testing',
    user_email: 'bilal+account4@levelupmarketplace.com',
    isGHLUser: false,
    UserInfo: {
        userName: 'Bilal Dev Testing',
        email: 'bilal+account4@levelupmarketplace.com',
        _id: '68f213784deb09185c37957f',
        userId: '68f213774deb09185c37957d',
    },
    agenct_config: { PluginOn: false, plugins: [] },
    agency_id: '6739f1be347a7f5974735cec',
    agentBuilder: null,
    assistants: [],
    business_name: 'Dev Testing',
    conversationId: '',
    createdAt: '2025-10-17T10:02:11.746Z',
    customer_id: 'cus_TFfxLV0IUmBv4f',
    email: 'bilal+account4@levelupmarketplace.com',
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    monthly_token_limit: 100000,
    monthly_token_usage: 4,
    nango_connected: false,
    number_of_additional_accounts: 0,
    number_of_ai_agents: 0,
    number_of_created_agents: 0,
    number_of_team_member: 0,
    number_of_tokens: 1,
    onboarding: { form: [], email: 'sangeeta.m.raghav@gmail.com', verified: true },
    openAgentBuilder: false,
    phone_number: '',
    planType: 'monthly',
    plan_id: '686fdebfe0e47b378ccaad35',
    promptlabels_ids: [],
    selected_assistant_id: null,
    stripe_cst_id: 'cus_TFfxLV0IUmBv4f',
    team_size: 'less-than-10',
    type: 'free',
    unlimited_ai_agents: true,
    updatedAt: '2025-10-17T10:27:36.412Z',
    useAgent: false,
    userId: '68f213774deb09185c37957d',
    zip_code: '',
    __v: 0,
    _id: '68f214234deb09185c3795a8',
};

export const staticDataGroa_prod = {
    UserInfo: {
        userName: 'Emo',
        email: 'emo+groatestaccount@maybetech.com',
        _id: '68aed3e536e9ef272063b191',
        userId: '68aed3e536e9ef272063b18f'
    },
    id: 'f2SLw9MVM5PzRBebdBv3',
    userUUID: '68aed3e536e9ef272063b191',
    chat_username: 'Emo',
    user_email: 'emo+groatestaccount@maybetech.com',
    isGHLUser: false,
    account_type: "Business",
    active_integrations: [],
    address: "",
    agenct_config: { PluginOn: false, plugins: [] },
    agency_id: "6867fdbb625cc5c79221235c",
    agentBuilder: "asst_Da5PQ2lgWWKxozuvylOLQVnT",
    apps: "Your AI",
    assistants: ['asst_9Kd728Waq5mOhBvB7xW68ITC'],
    business_name: "Groa Lead Gen iframe",
    city: "",
    conversationId: "",
    country: "",
    createdAt: "2025-12-02T11:19:10.481Z",
    email: "emo+groaleadgen@maybetech.com",
    first_name: "",
    ghl: {
        location_id: 'kadxNuS6MODBUrqqG5uP',
        company_id: 'LMIiNNA1awql96H7ZOhu',
        refresh_token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRoQ2xhc…VBmGkXtM7EFqGxyb1lrI6GUcNGYMCD3pAkMHtSVdS0SK_tEiI',
        access_token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRoQ2xhc…oguugyjXEfYExxw_LF4yTb_V53TnKhFHFeI4kYcpQpg86BJ40'
    },
    ghl_data: {
        id: 'kadxNuS6MODBUrqqG5uP',
        companyId: 'LMIiNNA1awql96H7ZOhu',
        name: 'groa°',
        address: ' ',
        city: ''
    },
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 129,
    nango_connected: false,
    number_of_additional_accounts: 0,
    number_of_ai_agents: 0,
    number_of_created_agents: 0,
    number_of_team_member: 10,
    number_of_tokens: 1000,
    onboarding: {
        website_url: 'https://www.r360growth.com/',
        email: 'emo+groatestaccount@maybetech.com',
        verified: true
    },
    openAgentBuilder: false,
    phone_number: "",
    planType: "monthly",
    promptlabels_ids: ['692ed37931029e6e8cdb657c', '693015158e9c968a6286bdee'],
    selected_assistant_id: null,
    state: "",
    time_zone: "Europe/London",
    type: "free",
    unlimited_ai_agents: true,
    updatedAt: "2025-12-03T16:45:17.249Z",
    useAgent: false,
    userId: null,
    zip_code: "",
    __v: 0,
    _id: "692ecb2e31029e6e8cdb5461"
};

export const iframeURL_prod = 'iframe.maybetech.com'
export const iframeURL_dev = "iframe.maybedev.ovh"
export const groaURL_prod = 'rfg-assessment.groa360.ai'

